import { Link, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { InfosAccordions } from "@features/home/common/InfosAccordions/InfosAccordions";
import { HELP_SUPPORT_URL, ROUTES } from "@constants";
import { useStyle } from "./style";

export const HomeMobileFrequentlyAskedQuestions = () => {
    const { classes } = useStyle();
    const { t } = useTranslation("home", { keyPrefix: "mobileFaq" });

    return (
        <section className={classes.section}>
            <Typography className={classes.sectionTitle} variant="h2">
                {t("title")}
            </Typography>
            <div className={classes.accordionsWrapper}>
                <InfosAccordions title={t("orderedSim.title")}>
                    <Typography color="secondary" variant="normal">
                        {t("orderedSim.content")}
                    </Typography>
                    <ol className={classes.list}>
                        <li>
                            <Typography variant="normal">{t("orderedSim.list1")}</Typography>
                        </li>
                        <li>
                            <Typography variant="normal">
                                <Trans
                                    components={{
                                        1: (
                                            <Link
                                                color="primary"
                                                href={HELP_SUPPORT_URL}
                                                rel="noopener noreferrer"
                                                target="_blank"
                                                underline="always"
                                            />
                                        ),
                                    }}
                                    i18nKey="mobileFaq.orderedSim.list2"
                                    ns="home"
                                />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="normal">{t("orderedSim.list3")}</Typography>
                        </li>
                        <li>
                            <Typography variant="normal">{t("orderedSim.list4")}</Typography>
                        </li>
                        <li>
                            <Typography variant="normal">
                                <Trans
                                    components={{
                                        1: (
                                            <Link
                                                color="primary"
                                                href={ROUTES.MYACCOUNT_URL ?? "#"}
                                                rel="noopener noreferrer"
                                                target="_blank"
                                                underline="always"
                                            />
                                        ),
                                    }}
                                    i18nKey="mobileFaq.orderedSim.list5"
                                    ns="home"
                                />
                            </Typography>
                        </li>
                    </ol>
                </InfosAccordions>
                <InfosAccordions title={t("moveNumber.title")}>
                    <div className={classes.paragraphs}>
                        <Typography variant="normal">{t("moveNumber.para1")}</Typography>
                        <Typography variant="normal">{t("moveNumber.para2")}</Typography>
                        <Typography variant="normal">{t("moveNumber.para3")}</Typography>
                        <Typography variant="normal">{t("moveNumber.para4")}</Typography>
                        <Typography variant="normal">
                            <Trans
                                components={{
                                    1: (
                                        <Link
                                            color="primary"
                                            href={ROUTES.MYACCOUNT_URL ?? "#"}
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            underline="always"
                                        />
                                    ),
                                }}
                                i18nKey="mobileFaq.moveNumber.para5"
                                ns="home"
                            />
                        </Typography>
                        <Typography variant="normal">
                            <Trans
                                components={{
                                    1: (
                                        <Link
                                            color="primary"
                                            href={ROUTES.MYACCOUNT_URL ?? "#"}
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            underline="always"
                                        />
                                    ),
                                }}
                                i18nKey="mobileFaq.moveNumber.para6"
                                ns="home"
                            />
                        </Typography>
                        <Typography variant="normal">{t("moveNumber.para7")}</Typography>
                        <Typography variant="normal">
                            <Trans
                                components={{
                                    1: (
                                        <Link
                                            color="primary"
                                            href={HELP_SUPPORT_URL}
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            underline="always"
                                        />
                                    ),
                                }}
                                i18nKey="mobileFaq.moveNumber.para8"
                                ns="home"
                            />
                        </Typography>
                    </div>
                </InfosAccordions>
                <InfosAccordions title={t("webchat.title")}>
                    <Typography color="secondary" variant="normal">
                        <Trans
                            components={{
                                1: (
                                    <Link
                                        color="primary"
                                        href={HELP_SUPPORT_URL}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        underline="always"
                                    />
                                ),
                                2: (
                                    <Link
                                        color="primary"
                                        href={ROUTES.MYACCOUNT_URL ?? "#"}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        underline="always"
                                    />
                                ),
                            }}
                            i18nKey="mobileFaq.webchat.content"
                            ns="home"
                        />
                    </Typography>
                </InfosAccordions>
            </div>
        </section>
    );
};
